<div class="p-inputgroup w-12 field">
  <p-inputNumber id="every" (onInput)="onInputParamChanged($event)" [(ngModel)]="param" [min]="1" [max]="59"
                 [showButtons]="false" buttonLayout="horizontal" incrementButtonIcon="pi pi-plus"
                 decrementButtonIcon="pi pi-minus"></p-inputNumber>
  <span class="p-inputgroup-addon">{{suffix}}</span>
</div>

